import React, { FC, useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Page } from '../../interfaces/Page';
import { ProtectedContainerProps } from '../../interfaces/PagesProps';
import AuthenticationContext from '../Authentication/AuthenticationContext';

export interface PagesProps {
  pages: Page[];
  ProtectedContainer: React.FC<ProtectedContainerProps>;
  notFoundPage?: Page;
}

const Pages: FC<PagesProps> = ({ pages, ProtectedContainer, notFoundPage }) => {
  const authCtx = useContext(AuthenticationContext);

  if (pages.length === 0) return notFoundPage?.component;

  return (
    <Switch>
      {pages.map((r) => {
        const Container = r.protected || authCtx.authenticationInfo.isAuthenticated ? ProtectedContainer : React.Fragment;
        return (
          <Route key={r.path} exact={r.exact} path={r.path}>
            <Container>
              {r.component}
            </Container>
          </Route>
        );
      })}
      {notFoundPage &&
        <Route>
          {notFoundPage.component}
        </Route>}
    </Switch>
  );
};

export default Pages;
